<template>
  <div class="order-item">
    <div class="order-item-header">
      <p class="order-item-id van-ellipsis">
        订单编号：
        <span>{{ order.orderId || order.orderParentId }}</span>
      </p>
      <p v-if="isShowStatusInOrder" :class="renderClassByStatus(order.status)" class="order-item-status">
        {{ order.status | cargoStatus(order) }}
      </p>
    </div>
    <store-item
      v-for="store in storeList"
      :key="store.orderId"
      :store="{...store, isRefund, orderParentId: order.orderId}"
      :isSplitOrder="isFatherOrder || isSplitOrder"
      :isPickOrder="store.deliveryWay === 2"
      :isShowStatus="!isShowStatusInOrder"
      style="margin-bottom: 10px"
    >
      <template v-if="store.orderClassifyType != '1'">
        <goods-item class="goods-item" v-if="store.orderDetails.length === 1" :goods="store.orderDetails[0]"></goods-item>
        <goods-list v-else :goodsList="store.orderDetails" :isShowGoodList="isShowGoodList"></goods-list>
      </template>
      <template v-else>
        <zy-goods-list :goodsList="store.orderDetails" :isShowGoodList="false" :doseCount="store.traditionalMedicineDoseCount"></zy-goods-list>
      </template>
      <div class="btn-wrapper" v-if="isFatherOrder && store.status === 51">
        <van-button
          hairline
          round
          plain
          class="gory-btn btn"
          color="#D9D9D9"
          size="small"
          @click.stop="openPopup(store)"
        >
          核销码
        </van-button>
      </div>
    </store-item>

    <section v-if="order.orderClassifyType == '1'" class="summary order-info">
      共{{ order.traditionalMedicineDoseCount }}剂，合计 ¥
      <span class="order-info-price">{{ order.totalPrice | price }}</span>
    </section>

    <template v-else>
      <section v-show="count" class="summary order-info">
        共{{ count }}件，合计 ¥
        <span class="order-info-price">{{ order.totalPrice | price }}</span>
      </section>
    </template>
  </div>
</template>
<script>
import utils from '@/util/index.js';
import { orderStatusEnum } from '@/constant';

import storeItem from '@/components/storeItem.vue';
import goodsItem from '@/components/goodsItem.vue';
import goodsList from '@/components/goodsList.vue';
import zyGoodsList from '@/components/zyGoodsList.vue';
import price from '@/components/Price.vue';
export default {
  components: {
    storeItem,
    goodsItem,
    goodsList,
    price,
    zyGoodsList
  },
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    isRefund: {
      type: Boolean,
      default: false  
    },
    isShowGoodList: {
      type: Boolean,
      default: false
    },
    isSplitOrder: {
      // 父订单列表详情页面，要拆分为子订单展示，所以要强制默认为是拆单的
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowPopup: false,
      pickCode: '',
      timeSection: ''
    };
  },
  computed: {
    isFatherOrder() {
      return this.order.subOrders && Array.isArray(this.order.subOrders) && this.order.subOrders.length > 0;
    },
    storeList() {
      if (this.isFatherOrder) {
        return this.order.subOrders || [];
      } else {
        // TODO
        return this.order.orderId ? [this.order] : [];
      }
    },
    count() {
      return this.order.itemCount || 0;
    },
    price() {
      return this.order.totalPrice || '';
    },
    expressPrice() {
      return this.order.expressFee || '';
    },
    isShowStatusInOrder() {
      const showStatusInOrderArr = [
        orderStatusEnum.unpayed,
        orderStatusEnum.canceled,
        orderStatusEnum.expired,
        orderStatusEnum.unaudit
      ];
      if (!this.isFatherOrder) {
        // 非拆单的状态直接展示在外面
        return true;
        // return showStatusInOrderArr.includes(this.order.status);
      } else {
        // 是拆单的，如果第一个状态匹配上，证明该订单里面所有子订单都是该状态，所以状态直接展示在外面
        const subOrder = (this.order.subOrders && this.order.subOrders[0]) || {};
        return showStatusInOrderArr.includes(subOrder.status);
      }
    }
  },
  methods: {
    renderClassByStatus(status) {
      const goryArr = [
        52, // 交易关闭
        22
      ];
      if (goryArr.includes(status)) return 'gory';
      return 'yellow';
    },
    // toPay() {
    //   this.$fetch
    //     .fetchGetTradeNo({
    //       orderId: this.order.orderParentId || this.order.orderId
    //     })
    //     .then((res) => {
    //       const tradeNo = res;
    //       const backParams = { orderId: this.order.orderId, prescription: this.order.orderType === 7 ? '1' : '2' };

    //       utils.payHandle.call(this, {
    //         tradeNo,
    //         backParams,
    //         channel: 'MEDIC_SALE'
    //       });
    //     })
    //     .catch((err) => {
    //       this.$toast('系统开小差了，请稍后再试');
    //     });
    // },
    openPopup(order) {
      this.$emit('showPopup', order);
    }
  }
};
</script>
<style lang="less" scoped>
.order-item {
  color: #262626;
  font-size: 14px;
  .goods-item {
    padding: 0;
  }
  &-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  &-id {
    flex: 1;
  }
  &-status {
    font-size: 12px;
    margin-left: 12px;
    &.gory {
      color: #bfbfbf;
    }
    &.yellow {
      color: #ff8200;
    }
  }
  .summary {
    text-align: right;
    padding-bottom: 16px;
    padding-top: 6px;
    font-size: 12px;
    .order-info-price {
      font-size: 16px;
    }
  }
}
.btn-wrapper {
  text-align: right;
  background: #ffffff;
  padding-bottom: 16px;
  margin-top: 4px;
  .btn {
    height: 32px;
  }
  .gory-btn {
    /deep/ .van-button__content {
      color: #595959;
    }
  }
  .btn-pay {
    width: 78px;
    height: 32px;
    border-radius: 8px;
    background: #1e8dff;
  }
}
.self-popup-box {
  background: transparent;
  .popup-container {
    width: 100%;
    padding: 36px 47px;
    background: #fff;
    border-radius: 12px;
    text-align: center;
    color: #262626;
    font-size: 14px;
    min-width: 270px;
    &-title {
      margin-bottom: 20px;
    }
    &-code {
      font-size: 32px;
      color: #1e8dff;
      font-weight: 500;
      margin-bottom: 32px;
    }
    &-time {
      width: 100%;
      font-size: 12px;
      color: #1e8dff;
      .label {
        color: #8c8c8c;
      }
    }
  }
}
</style>
